import OrganisationLayout from "../layout/OrganisationLayout";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useSelector } from "react-redux";
import {
  formatOrganisationRole,
  getOrganisationGroupRole,
  getOrganisationRoleAccess,
} from "../utils/roleAccess";

export default function OrganisationGroupsSchoolDetails() {
  const userData = useSelector((state) => state?.authSlice.userData?.payload);
  const organisationGroup = userData?.organisationGroupId;
  const access = getOrganisationRoleAccess(userData);

  return (
    <OrganisationLayout>
      <Container fluid>
        <div className="heading-top mt-5 mb-2">
          <p className="organization-crumb">Organisation Group / Settings</p>
          <h2>School Details</h2>
        </div>

        <Row className="g-4 mt-1">
          <Col xl={8}>
            <section className="organisation-groups-table-shell organisation-panel-card">
              <div className="organisation-panel-heading">
                <div>
                  <h3>Organisation Group</h3>
                  <p>Display membership context in a way that feels native to the current app.</p>
                </div>
              </div>

              <div className="organisation-profile-grid organisation-profile-grid-wide">
                <div>
                  <span>Group Name</span>
                  <strong>{organisationGroup?.name || "Not connected"}</strong>
                </div>
                <div>
                  <span>Your Role</span>
                  <strong>{formatOrganisationRole(getOrganisationGroupRole(userData))}</strong>
                </div>
                <div>
                  <span>Group Email</span>
                  <strong>{organisationGroup?.email || "Not available"}</strong>
                </div>
                <div>
                  <span>Group Address</span>
                  <strong>{organisationGroup?.address || "Not available"}</strong>
                </div>
              </div>

              <div className="organisation-note-banner organisation-note-banner-inline">
                {access.canViewSchoolDetails
                  ? "This page is ready for organisation-group membership messaging, support text, and related help content."
                  : "Your role does not currently have school details management access."}
              </div>
            </section>
          </Col>

          <Col xl={4}>
            <section className="organisation-groups-table-shell organisation-panel-card">
              <div className="organisation-panel-heading">
                <div>
                  <h3>Help</h3>
                  <p>Keep supporting information lightweight and polished.</p>
                </div>
              </div>

              <div className="organisation-support-copy">
                <strong>What&apos;s this?</strong>
                <p>
                  Organisation groups let selected staff review activity across
                  multiple member organisations without changing the main school-side experience.
                </p>
              </div>
            </section>
          </Col>
        </Row>
      </Container>
    </OrganisationLayout>
  );
}
